import { Response } from '@marketplace-web/core-api/api-client-util'

import {
  BumpMinimumPriceDto,
  BumpMinimumPriceModel,
  BumpMinimumPriceResp,
} from '../types/bump-minimum-price'
import { transformCurrencyDtoToModel } from './currency'

export const transformBumpMinimumPrice = (dto: BumpMinimumPriceDto): BumpMinimumPriceModel => ({
  basePrice: transformCurrencyDtoToModel(dto.base_price),
  finalPrice: transformCurrencyDtoToModel(dto.final_price),
  discountAmount: transformCurrencyDtoToModel(dto.discount_amount),
  hasFreeBumps: dto.has_free_bumps,
})

export const transformBumpMinimumPriceResponse = (response: Response<BumpMinimumPriceResp>) =>
  transformBumpMinimumPrice(response.minimum_price)
